import React from 'react';
import { XIcon } from 'lucide-react';
import { painClosing, painGroups, painTitle } from '../data/content';
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-186" data-mp="2pepgxh5h0tl4">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-187" data-mp="2bgiqun6rjxw0">
        <h2 className="mx-auto max-w-4xl text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-188" data-mp="2bi2cktb6v156">
          {painTitle}
        </h2>

        <div className="mx-auto mt-12 grid max-w-4xl gap-6 md:grid-cols-2 md:gap-8" data-id="element-189" data-mp="21olfngfr95xa">
          {painGroups.map(group => <div key={group.audience} className="flex h-full flex-col" data-id="element-190" data-mp="26ih7s29c7ykj">
              <h3 className="text-xl font-extrabold tracking-tight text-slate-900 md:text-2xl" data-id="element-191" data-mp="1sr2ri36tebh6">
                {group.audience}
              </h3>
              <ul className="mt-5 space-y-3" data-id="element-192" data-mp="1iqilkn8coism">
                {group.points.map(point => <li key={point} className="flex items-start gap-4 rounded-2xl bg-red-50 px-5 py-4 ring-1 ring-red-100" data-id="element-193" data-mp="1npvg7u5gqu5r">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600" data-id="element-194" data-mp="oauacmmo7wca">
                      <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-195" data-mp="12avb822xr3rr" />
                    </span>
                    <span className="font-medium leading-snug text-slate-900" data-id="element-196" data-mp="xba7lectm78p">{point}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-4xl" data-id="element-197" data-mp="5l5ij2e48w15">
          {painClosing}
        </p>
      </div>
    </section>;
}